import {game} from "../main";

const lookUpMap = {};

export default function checkSheet(frame) {
  if (lookUpMap[frame] !== undefined) return lookUpMap[frame];

  // @ts-ignore
  const entry = Object.entries(game.cache._cache.image)
    .find(([imageKey, imageData]: any) => {
      return imageData.frameData && imageData.frameData._frameNames[frame] !== undefined;
    });

  if (entry) lookUpMap[frame] = entry ? entry[0] : null;

  return entry ? entry[0] : null;
}
